import { Chart } from '@frontend/chart/types';

import { createSingleSeriesTimeSeriesMockData } from '../../../mocks/create-time-series-mock-data';
import { WEEKDAY_WEEK_HEATMAP_WEEKS } from '../../../utils/to-weekday-week-heatmap-series';

const base = createSingleSeriesTimeSeriesMockData({
    days: WEEKDAY_WEEK_HEATMAP_WEEKS * 7,
    scale: 1,
    seriesName: 'Uptime'
});

export const IOTS_UPTIME_WEEKDAY_HEATMAP_CHART_MOCK_DATA: Chart = {
    series: [
        {
            name: 'Uptime',
            data: base.series[0].data.map((point, index) => ({
                label: point.label,
                value: Math.min(100, Math.max(85, 96 - (index % 13 === 0 ? 10 : 0) - (index % 17 === 0 ? 5 : 0)))
            }))
        }
    ]
};
